import type {I18nKey} from "@corporatesclub/shared";

export function PdpDeliveryPanel({deliveryLabel, t}: {deliveryLabel: string; t: (key: I18nKey) => string}) {
  return (
    <div className="pvPdpDelivery">
      <div className="pvPdpDelivery__lead">
        <span className="pvPdpDelivery__leadIcon" aria-hidden="true">
          <i className="fa fa-calendar-check-o" />
        </span>
        <div className="pvPdpDelivery__leadText">
          <strong>{t("Estimated delivery")}</strong>
          <span className="pvPdpDelivery__leadDate">{deliveryLabel}</span>
        </div>
      </div>
      <ul className="pvPdpDelivery__list">
        <li className="pvPdpDelivery__row">
          <span className="pvPdpDelivery__rowIcon" aria-hidden="true"><i className="fa fa-truck" /></span>
          <span className="pvPdpDelivery__rowText">
            <strong>{t("Delivery in Romania")}</strong> — {t("from 14.90 lei")}
          </span>
        </li>
        <li className="pvPdpDelivery__row">
          <span className="pvPdpDelivery__rowIcon" aria-hidden="true"><i className="fa fa-gift" /></span>
          <span className="pvPdpDelivery__rowText">
            <strong>{t("Free shipping title")}</strong> <em>{t("over 100 lei")}</em>
          </span>
        </li>
        <li className="pvPdpDelivery__row">
          <span className="pvPdpDelivery__rowIcon" aria-hidden="true"><i className="fa fa-refresh" /></span>
          <span className="pvPdpDelivery__rowText">
            <strong>{t("Free returns")}</strong> — {t("30 days, risk-free")}
          </span>
        </li>
      </ul>
      <div className="pvPdpDelivery__help">
        <span className="pvPdpDelivery__helpIcon" aria-hidden="true"><i className="fa fa-phone" /></span>
        <span>
          {t("Need help?")}{" "}
          <a href="tel:+40739973400">0739 973 400</a>
        </span>
      </div>
    </div>
  );
}
